// extracted by mini-css-extract-plugin
export default {"button":"fl-z","reviewSort":"gl-z"};